module.exports = __webpack_public_path__ + "static/president-armstrong-ccu-inauguration-2c0ca90150af5c889a17bd74b2b521f2.png";